export const BasicPath = "admin-pniv/";

export const GlobalPath = "";

export const RootPath = GlobalPath + BasicPath;